import { VFC, useMemo } from 'react';
import { ElectricityMeterMeasurementType } from '@enmon/commons';
import { FormattedMessage, useIntl } from 'react-intl';
import { Select } from '../../Select';
import { SelectMessages as messages } from '../../messages';
import { electricityMeterMeasurementTypeTranslated } from '../../../Form/meter_details/constants';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';

interface ElectricityMeterMeasurementTypeSelectProps {
  value?: ElectricityMeterMeasurementType;
  onChange?: (value: ElectricityMeterMeasurementType) => void;
}

export const ElectricityMeterMeasurementTypeSelect: VFC<ElectricityMeterMeasurementTypeSelectProps> = ({
  ...restProps
}: ElectricityMeterMeasurementTypeSelectProps) => {
  const intl = useIntl();

  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const electricityMeterMeasurementTypeOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(ElectricityMeterMeasurementType),
        suggestedValue: meterModelSuggestions?.measurementType?.value,
        suggestedSelection: meterModelSuggestions?.measurementType?.selection,
        labelFormatter: (value: ElectricityMeterMeasurementType) =>
          intl.formatMessage(electricityMeterMeasurementTypeTranslated[value]),
      }),
    [meterModelSuggestions, intl],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={electricityMeterMeasurementTypeOptions}
      placeholder={<FormattedMessage {...messages.measurementTypeSelect} />}
      {...restProps}
    />
  );
};
